import Button from '@mui/material/Button'
import { minWidth } from '@mui/system'
import styled, { css } from 'styled-components'
import { COLORS, SPACING, TYPOGRAPHY, FONTS } from 'utils'

export interface ButtonStyle {
  marginTop?: string
  marginBottom?: string
  marginLeft?: string
  marginRight?: string
  backgroundColor?: string
  textColor?: string
  minWidth?: string
  borderColor?: string
  width?: string
  hide?: boolean
  variantButton?: 'text' | 'outlined' | 'default'
  boxShadow?: string
}

export const ButtonCustom = styled(Button)<ButtonStyle>`
  margin: ${SPACING.spacing5};
  font-size: ${TYPOGRAPHY.captionSize12};
  font-family: Arial;
  ${({ minWidth }) => minWidth && `min-width: ${minWidth};`}
  font-weight: ${FONTS.regular};
  width: ${({ width }) => width || 'auto'};
  visibility: ${({ hide }) => hide && 'hidden'};
  margin-top: ${({ marginTop }) => marginTop || '0'};
  margin-bottom: ${({ marginBottom }) => marginBottom || '0'};
  margin-left: ${({ marginLeft }) => marginLeft || '0'};
  margin-right: ${({ marginRight }) => marginRight || '0'};
  color: ${({ textColor }) => textColor || COLORS.black};
  padding: 4px 0px 4px 0px;
  :hover {
    opacity: 0.6;
  }

  ${({ variantButton, backgroundColor, borderColor }) =>
    variantButton === 'default'
      ? css`
          background: ${backgroundColor ? backgroundColor : COLORS.primary};
          border: 0.1rem solid ${borderColor ? borderColor : COLORS.primary};
          :hover {
            background-color: ${backgroundColor
              ? backgroundColor
              : COLORS.primary};
          }
        `
      : variantButton === 'outlined'
      ? css`
          background-color: ${COLORS.white};
          border: 0.1rem solid ${borderColor ? borderColor : COLORS.black};
          box-shadow: none;
        `
      : css`
          background-color: ${COLORS.white};
          border: none;
          box-shadow: none;
        `}
`
